import ContainerWithTabs from "Components/Admin/ContainerWithTabs";

import NotificationDetails from "./Components/NotificationDetails";
import UpdateNotification from "./Components/UpdateNotifications";

const ManageNotification = () => {
  return (
    <ContainerWithTabs
      mt="0px"
      fitContent
      tabs={[
        {
          title: "Detalhes",
          component: <NotificationDetails />,
        },
        {
          title: "Editar",
          component: <UpdateNotification />,
        },
      ]}
    />
  );
};

export default ManageNotification;
